/**
 * Packery-directive, eli angular-wrapper packerylle.
 *
 * Käyttö esim:
 * <div packery="someTileList" on-init="DoSomething(packery, controls)" min-width="100" column-width="50" gutter="10"></div>
 *
 * Parametrit ja callbackit:
 *
 * packery          Direktiivin instanssin nimi. Vastaavalla nimellä voi hakea direktiivin instanssin
 *                  PackeryService.Get():llä.
 * min-width        Minimileveys, jolloin packerya vielä käytetään. Jos elementin leveys kapenee alle tämän
 *                  arvon, packery poistuu käytöstä (deletoidaan). Kun palataan yli tämän arvon, uusi
 *                  packery luodaan.
 * column-width     Yhden kolumnin leveys. Ei sisällä gutteria.
 * gutter           Margin kolumnien välillä.
 *
 * on-init          Callback, jota kutsutaan kun packery-direktiivi alustetaan.
 *                  Parametreinä:
 *
 *                      packery - natiivi packery-instanssi
 *                      controls - kontrollifunktiot, jolla voi kontrolloida packerya
 * autoInitLayout   Jos asetettu trueksi, ajaa ResetAndReLayoutin automaattisesti alustuksessa.
 */
app.directive('packery', ["$rootScope", "$parse", "$timeout", "PackeryService", function($rootScope, $parse, $timeout, PackeryService) {

	return {
		restrict: 'EA',
		scope: {

		},
		link: function(scope, element, attrs) {
			if (!window['isIE']) {
				return;
			}

			function _createNewPackery() {
				scope.name = attrs.packery;
				scope.packery = new Packery(element[0], {
						itemSelector: attrs.itemSelector,
						columnWidth: parseInt(attrs.columnWidth),
						gutter: parseInt(attrs.gutter),
						transitionDuration: 0
					}
				);
				scope.packery.layout();
				if(attrs.packery !== undefined) {
					PackeryService.Register(scope.name, scope.packery, scope.controls);

				}
			}

			element.on('$destroy', function() {
				PackeryService.Unregister(scope.name);
			});

			scope.attrs = attrs;
			if(attrs.onInit) {
				scope.onInit = $parse(attrs.onInit);
			}

			if(attrs.autoInitLayout === true || attrs.autoInitLayout == 'true') {
				$timeout(function() {
					scope.controls.ResetAndReLayout();
				});
			}

			if($(window).width() > attrs["minWidth"]) {
				_createNewPackery();
			} else {
				element.addClass('disabled');
			}

			$(window).on('resize', function(event) {
				if(scope.packery !== undefined && $(window).width() < parseInt(scope.attrs["minWidth"])) {
					scope.packery.destroy();
					scope.packery.isDestroyed = true;
					scope.packery = undefined;
					element.addClass('disabled');
					$timeout(function() {
						element.removeAttr("style");
						element.find("> *").removeAttr("style");
					}, 500);

				}
				else if(scope.packery === undefined && $(window).width() >= parseInt(scope.attrs["minWidth"])) {
					_createNewPackery();
					element.removeClass('disabled');
					if(typeof(scope.onInit) != 'undefined') {
						scope.onInit(scope.$parent, {
							packery: scope.packery,
							controls: scope.controls
						});
					}
					console.log("create packery");
				}
			});

			if(typeof(scope.onInit) != 'undefined') {
				scope.onInit(scope.$parent, {
					packery: scope.packery,
					controls: scope.controls
				});
			}
		},

		controller: ["$scope", function($scope) {

			/**
			 * Packery-direktiivin kontrollit, jotka ovat näkyvissä ulkopuolelle.
			 * @type {{}}
			 */
			$scope.controls = {};

			$scope.controls.ResetAndReLayout = function() {
				if($scope.packery !== undefined) {
					if(!$scope.packery.isDestroyed) {
						var arr = $scope.packery.items.slice();
						arr.forEach(function(item) {
							$scope.packery.remove(item);
						});
						$scope.packery.reloadItems();

						$timeout(function() {
							$scope.packery.layout();
						});
					}
				}
			};
		}]
	};

}]);
